"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _HTTPError = _interopRequireDefault(require("../model/HTTPError"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

var _Sequence = _interopRequireDefault(require("../model/Sequence"));

var _SequenceFromDB = _interopRequireDefault(require("../model/SequenceFromDB"));

var _SequencesFromDB = _interopRequireDefault(require("../model/SequencesFromDB"));

var _Tracking = _interopRequireDefault(require("../model/Tracking"));

var _TrackingFromDB = _interopRequireDefault(require("../model/TrackingFromDB"));

var _TrackingsFromDB = _interopRequireDefault(require("../model/TrackingsFromDB"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
* Default service.
* @module api/DefaultApi
* @version 0.1.1
*/


var DefaultApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DefaultApi. 
  * @alias module:api/DefaultApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DefaultApi(apiClient) {
    _classCallCheck(this, DefaultApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Delete History For Guid
   * @param {String} guid 
   * @param {String} authorization 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */


  _createClass(DefaultApi, [{
    key: "deleteHistoryForGuidHistoryGuidDeleteWithHttpInfo",
    value: function deleteHistoryForGuidHistoryGuidDeleteWithHttpInfo(guid, authorization) {
      var postBody = null; // verify the required parameter 'guid' is set

      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling deleteHistoryForGuidHistoryGuidDelete");
      } // verify the required parameter 'authorization' is set


      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling deleteHistoryForGuidHistoryGuidDelete");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/history/{guid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete History For Guid
     * @param {String} guid 
     * @param {String} authorization 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */

  }, {
    key: "deleteHistoryForGuidHistoryGuidDelete",
    value: function deleteHistoryForGuidHistoryGuidDelete(guid, authorization) {
      return this.deleteHistoryForGuidHistoryGuidDeleteWithHttpInfo(guid, authorization).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Obtain Multiple Sequences
     * @param {String} authorization 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locale 
     * @param {String} opts.subject 
     * @param {Number} opts.grade 
     * @param {Number} opts.module 
     * @param {Number} opts.path 
     * @param {Number} opts.activity 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SequencesFromDB} and HTTP response
     */

  }, {
    key: "obtainMultipleSequencesSearchGetWithHttpInfo",
    value: function obtainMultipleSequencesSearchGetWithHttpInfo(authorization, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'authorization' is set

      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling obtainMultipleSequencesSearchGet");
      }

      var pathParams = {};
      var queryParams = {
        'locale': opts['locale'],
        'subject': opts['subject'],
        'grade': opts['grade'],
        'module': opts['module'],
        'path': opts['path'],
        'activity': opts['activity']
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SequencesFromDB["default"];
      return this.apiClient.callApi('/search', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Obtain Multiple Sequences
     * @param {String} authorization 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locale 
     * @param {String} opts.subject 
     * @param {Number} opts.grade 
     * @param {Number} opts.module 
     * @param {Number} opts.path 
     * @param {Number} opts.activity 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SequencesFromDB}
     */

  }, {
    key: "obtainMultipleSequencesSearchGet",
    value: function obtainMultipleSequencesSearchGet(authorization, opts) {
      return this.obtainMultipleSequencesSearchGetWithHttpInfo(authorization, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Obtain Multiple Trackings
     * @param {String} authorization 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locale 
     * @param {String} opts.subject 
     * @param {Number} opts.grade 
     * @param {Number} opts.module 
     * @param {Number} opts.path 
     * @param {Number} opts.activity 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TrackingsFromDB} and HTTP response
     */

  }, {
    key: "obtainMultipleTrackingsSearchTrackingsGetWithHttpInfo",
    value: function obtainMultipleTrackingsSearchTrackingsGetWithHttpInfo(authorization, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'authorization' is set

      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling obtainMultipleTrackingsSearchTrackingsGet");
      }

      var pathParams = {};
      var queryParams = {
        'locale': opts['locale'],
        'subject': opts['subject'],
        'grade': opts['grade'],
        'module': opts['module'],
        'path': opts['path'],
        'activity': opts['activity']
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TrackingsFromDB["default"];
      return this.apiClient.callApi('/search_trackings', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Obtain Multiple Trackings
     * @param {String} authorization 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locale 
     * @param {String} opts.subject 
     * @param {Number} opts.grade 
     * @param {Number} opts.module 
     * @param {Number} opts.path 
     * @param {Number} opts.activity 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TrackingsFromDB}
     */

  }, {
    key: "obtainMultipleTrackingsSearchTrackingsGet",
    value: function obtainMultipleTrackingsSearchTrackingsGet(authorization, opts) {
      return this.obtainMultipleTrackingsSearchTrackingsGetWithHttpInfo(authorization, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Obtain Unique Sequence Or 404
     * @param {String} locale 
     * @param {String} subject 
     * @param {Number} grade 
     * @param {Number} module 
     * @param {Number} path 
     * @param {Number} activity 
     * @param {String} authorization 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SequenceFromDB} and HTTP response
     */

  }, {
    key: "obtainUniqueSequenceOr404SequenceGetWithHttpInfo",
    value: function obtainUniqueSequenceOr404SequenceGetWithHttpInfo(locale, subject, grade, module, path, activity, authorization) {
      var postBody = null; // verify the required parameter 'locale' is set

      if (locale === undefined || locale === null) {
        throw new Error("Missing the required parameter 'locale' when calling obtainUniqueSequenceOr404SequenceGet");
      } // verify the required parameter 'subject' is set


      if (subject === undefined || subject === null) {
        throw new Error("Missing the required parameter 'subject' when calling obtainUniqueSequenceOr404SequenceGet");
      } // verify the required parameter 'grade' is set


      if (grade === undefined || grade === null) {
        throw new Error("Missing the required parameter 'grade' when calling obtainUniqueSequenceOr404SequenceGet");
      } // verify the required parameter 'module' is set


      if (module === undefined || module === null) {
        throw new Error("Missing the required parameter 'module' when calling obtainUniqueSequenceOr404SequenceGet");
      } // verify the required parameter 'path' is set


      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling obtainUniqueSequenceOr404SequenceGet");
      } // verify the required parameter 'activity' is set


      if (activity === undefined || activity === null) {
        throw new Error("Missing the required parameter 'activity' when calling obtainUniqueSequenceOr404SequenceGet");
      } // verify the required parameter 'authorization' is set


      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling obtainUniqueSequenceOr404SequenceGet");
      }

      var pathParams = {};
      var queryParams = {
        'locale': locale,
        'subject': subject,
        'grade': grade,
        'module': module,
        'path': path,
        'activity': activity
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SequenceFromDB["default"];
      return this.apiClient.callApi('/sequence', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Obtain Unique Sequence Or 404
     * @param {String} locale 
     * @param {String} subject 
     * @param {Number} grade 
     * @param {Number} module 
     * @param {Number} path 
     * @param {Number} activity 
     * @param {String} authorization 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SequenceFromDB}
     */

  }, {
    key: "obtainUniqueSequenceOr404SequenceGet",
    value: function obtainUniqueSequenceOr404SequenceGet(locale, subject, grade, module, path, activity, authorization) {
      return this.obtainUniqueSequenceOr404SequenceGetWithHttpInfo(locale, subject, grade, module, path, activity, authorization).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Obtain Unique Tracking Or 404
     * @param {String} locale 
     * @param {String} subject 
     * @param {Number} grade 
     * @param {Number} module 
     * @param {Number} path 
     * @param {Number} activity 
     * @param {String} authorization 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TrackingFromDB} and HTTP response
     */

  }, {
    key: "obtainUniqueTrackingOr404TrackingGetWithHttpInfo",
    value: function obtainUniqueTrackingOr404TrackingGetWithHttpInfo(locale, subject, grade, module, path, activity, authorization) {
      var postBody = null; // verify the required parameter 'locale' is set

      if (locale === undefined || locale === null) {
        throw new Error("Missing the required parameter 'locale' when calling obtainUniqueTrackingOr404TrackingGet");
      } // verify the required parameter 'subject' is set


      if (subject === undefined || subject === null) {
        throw new Error("Missing the required parameter 'subject' when calling obtainUniqueTrackingOr404TrackingGet");
      } // verify the required parameter 'grade' is set


      if (grade === undefined || grade === null) {
        throw new Error("Missing the required parameter 'grade' when calling obtainUniqueTrackingOr404TrackingGet");
      } // verify the required parameter 'module' is set


      if (module === undefined || module === null) {
        throw new Error("Missing the required parameter 'module' when calling obtainUniqueTrackingOr404TrackingGet");
      } // verify the required parameter 'path' is set


      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling obtainUniqueTrackingOr404TrackingGet");
      } // verify the required parameter 'activity' is set


      if (activity === undefined || activity === null) {
        throw new Error("Missing the required parameter 'activity' when calling obtainUniqueTrackingOr404TrackingGet");
      } // verify the required parameter 'authorization' is set


      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling obtainUniqueTrackingOr404TrackingGet");
      }

      var pathParams = {};
      var queryParams = {
        'locale': locale,
        'subject': subject,
        'grade': grade,
        'module': module,
        'path': path,
        'activity': activity
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TrackingFromDB["default"];
      return this.apiClient.callApi('/tracking', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Obtain Unique Tracking Or 404
     * @param {String} locale 
     * @param {String} subject 
     * @param {Number} grade 
     * @param {Number} module 
     * @param {Number} path 
     * @param {Number} activity 
     * @param {String} authorization 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TrackingFromDB}
     */

  }, {
    key: "obtainUniqueTrackingOr404TrackingGet",
    value: function obtainUniqueTrackingOr404TrackingGet(locale, subject, grade, module, path, activity, authorization) {
      return this.obtainUniqueTrackingOr404TrackingGetWithHttpInfo(locale, subject, grade, module, path, activity, authorization).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Store Sequence
     * @param {String} authorization 
     * @param {module:model/Sequence} sequence 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Sequence} and HTTP response
     */

  }, {
    key: "storeSequenceSequencePostWithHttpInfo",
    value: function storeSequenceSequencePostWithHttpInfo(authorization, sequence) {
      var postBody = sequence; // verify the required parameter 'authorization' is set

      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling storeSequenceSequencePost");
      } // verify the required parameter 'sequence' is set


      if (sequence === undefined || sequence === null) {
        throw new Error("Missing the required parameter 'sequence' when calling storeSequenceSequencePost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Sequence["default"];
      return this.apiClient.callApi('/sequence', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Store Sequence
     * @param {String} authorization 
     * @param {module:model/Sequence} sequence 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Sequence}
     */

  }, {
    key: "storeSequenceSequencePost",
    value: function storeSequenceSequencePost(authorization, sequence) {
      return this.storeSequenceSequencePostWithHttpInfo(authorization, sequence).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Store Tracking
     * @param {String} authorization 
     * @param {module:model/Tracking} tracking 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Tracking} and HTTP response
     */

  }, {
    key: "storeTrackingTrackingPostWithHttpInfo",
    value: function storeTrackingTrackingPostWithHttpInfo(authorization, tracking) {
      var postBody = tracking; // verify the required parameter 'authorization' is set

      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling storeTrackingTrackingPost");
      } // verify the required parameter 'tracking' is set


      if (tracking === undefined || tracking === null) {
        throw new Error("Missing the required parameter 'tracking' when calling storeTrackingTrackingPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Tracking["default"];
      return this.apiClient.callApi('/tracking', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Store Tracking
     * @param {String} authorization 
     * @param {module:model/Tracking} tracking 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Tracking}
     */

  }, {
    key: "storeTrackingTrackingPost",
    value: function storeTrackingTrackingPost(authorization, tracking) {
      return this.storeTrackingTrackingPostWithHttpInfo(authorization, tracking).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return DefaultApi;
}();

exports["default"] = DefaultApi;